<script setup lang="ts">
import Item from '../Item/index.vue'
import HorizontalScrollItem from '@/components/HorizontalScroll/Item.vue'
import type { Topic } from '~~/src/types/topic'
import HorizontalScroll from '@/components/HorizontalScroll/index.vue'

const props = defineProps<{
  topics: Topic[]
  isBubbles?: boolean
  useAsFilter?: boolean
  activeId?: number
}>()

defineEmits<{
  (event: 'selectTopic', value?: Topic): void
}>()

const { activeId } = toRefs(props)
const route = useRoute()
const routeId = computed(() => asArray(route.params.id)[0])
</script>

<template>
  <HorizontalScroll
    v-if="topics.length"
    as="ul"
    :class="{ 'gap-2': isBubbles }"
    container-class="space-x-6 px-3"
  >
    <HorizontalScrollItem as="li">
      <Item
        :topic="undefined"
        :is-active="!activeId && route.path === '/'"
        :is-bubbles="isBubbles"
        :use-as-filter="useAsFilter"
        @click="(t) => $emit('selectTopic', t)"
      />
    </HorizontalScrollItem>

    <template v-for="topic in topics" :key="topic.id">
      <HorizontalScrollItem v-if="!useAsFilter || topic.nElementals" class="flex-shrink-0" as="li">
        <Item
          :topic="topic"
          :is-active="activeId === topic.id || topic.id === parseInt(routeId) || topic.url === routeId"
          :is-bubbles="isBubbles"
          :use-as-filter="useAsFilter"
          @click="(t) => $emit('selectTopic', t)"
        />
      </HorizontalScrollItem>
    </template>
  </HorizontalScroll>
</template>
